import React from 'react';

/** Renders an image only when a src is provided. No placeholder graphics, no text. */
export function Img({ src, alt = '', className = '' }) {
  if (!src) return null;
  return <img src={src} alt={alt} className={className} loading="lazy" />;
}

/** Official UKGM hero banner used on the homepage. */
export const UKGM_HERO_BANNER_URL = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_ukgm-foundation/artifacts/l5fuh0jl_Screenshot_2026-07-31-01-10-08-42_e55d67e6190e80b161828c9e2aa77e01~2.jpg';

/** Official UKGM logo — circular emblem with the golden bull. */
export const UKGM_LOGO_URL = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_ukgm-foundation/artifacts/mqsvk5hn_Screenshot_2026-07-13-12-10-54-86_864d69589a2cbc1033c6d7a331844b5c~2.jpg';

/** Official portrait of Founder — Mr. Udhhab Madhav Maharaj. */
export const FOUNDER_PHOTO_URL = 'https://customer-assets-7cd3h4nn.emergentagent.net/job_ukgm-foundation/artifacts/gn94o3rs_Screenshot_2026-06-27-00-45-34-17_e55d67e6190e80b161828c9e2aa77e01~2.jpg';

/** Official social media & links. */
export const UKGM_LINKS = {
  visiting_card: 'https://udhhab-madhav-maharaj.businessbay.tech/',
  instagram: 'https://instagram.com/ukgm_mission',
  facebook: 'https://facebook.com/share/1QH2aXQk5b/',
  linkedin: 'https://linkedin.com/in/udhhab-madhav-maharaj-a185bb12a',
  whatsapp: 'https://wa.me/917447261155',
  razorpay: 'https://razorpay.me/@universalkrishnagaukulmis1670',
  founder_email: 'udhavmadhav108@gmail.com',
};

export function UKGMLogo({ className = 'w-11 h-11', ring = true }) {
  return (
    <img
      src={UKGM_LOGO_URL}
      alt="Universal Krishna Gaukul Mission — Official Logo"
      className={`${className} rounded-full object-cover ${ring ? 'ring-1 ring-[#D4AF37]' : ''}`}
      loading="eager"
    />
  );
}
